import React from 'react'
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { OrderConfigurationForm } from '../../../components/Common/Forms';


const InstaCollectOrderConfigDrawer = (props) => {

    return (
        <EaseDrawer
            placement="right"
            width={522}
            height={810}
            visible={props.visible}
            title={"Order Configuration"}
            destroyOnClose={true}
            onClose={props.onClose}
            className="instacollect-order-config-drawer"
            hideBackArrow={true}
            hideFooter={true}
        >
            <OrderConfigurationForm onClose={props.onClose}/>
        </EaseDrawer>
    )
}

export default InstaCollectOrderConfigDrawer;